@if (isImpersonating) {
    <div class="impersonation-chip">
        <mat-icon class="impersonation-chip__icon" aria-hidden="true">fingerprint</mat-icon>
        <span class="impersonation-chip__label">{{ 'menu.header.impersonating' | transloco }}</span>
        @if (subject) {
            <span class="impersonation-chip__subject">{{ subject }}</span>
        }
        <button type="button" class="impersonation-chip__stop" [disabled]="stopping" (click)="stopImpersonation()">
            {{
                stopping
                    ? ('menu.header.stoppingImpersonation' | transloco)
                    : ('menu.header.stopImpersonation' | transloco)
            }}
        </button>
    </div>
}
